import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth/types';
import StayDashboard from 'src/features/stay/components/dashboard/StayDashboard';
import useHasPermissions from 'src/hooks/useHasPermissions';
import VisitorsLayout from 'src/features/routes/visitors/VisitorsLayout';
import { STAY_TYPE } from 'src/features/stay/types';
import VisitorsDashboard from 'src/features/visitor/components/VisitorDashboard';

const VisitorsRoutes = () => {
    const accessActiveStaysPermission = useHasPermissions([PERMISSION.ACCESS_ACTIVE_STAYS]);
    const accessPastStaysPermission = useHasPermissions([PERMISSION.ACCESS_PAST_STAYS]);
    const accessVisitors = useHasPermissions([PERMISSION.ACCESS_VISITORS]);

    return (
        <Routes>
            <Route path='' element={<VisitorsLayout />}>
                <Route path="*" element={<Navigate to=".." />} />
            </Route>
                {accessActiveStaysPermission && (
                    <Route path="active-stays/dashboard/:stayId" element={<StayDashboard stayType={STAY_TYPE.ACTIVE} />} />
                )}
                {accessPastStaysPermission && (
                    <Route path="past-stays/dashboard/:stayId" element={<StayDashboard stayType={STAY_TYPE.PAST} />} />
                )}
                {accessVisitors && <Route path="visitors/:visitorId" element={<VisitorsDashboard />} />}
        </Routes>
    );
};

export default VisitorsRoutes;
